import { render, staticRenderFns } from "./Walle-Change-Record.vue?vue&type=template&id=57b7659e&"
import script from "./Walle-Change-Record.vue?vue&type=script&lang=js&"
export * from "./Walle-Change-Record.vue?vue&type=script&lang=js&"
import style0 from "./Walle-Change-Record.vue?vue&type=style&index=0&id=57b7659e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports